export const getters = {
  getUiFlags: $state => $state.uiFlags,
  getCampaign: $state => $state.campaign,
  getTasks: $state => $state.tasks,
  getEvents: $state => $state.events,
  getScripts: $state => $state.scripts,
  getWorkers: $state => $state.workers,
  getFieldSummary: $state => $state.fieldSummary,
  getFieldByCity: $state => $state.fieldByCity,
  getFieldHierarchy: $state => $state.fieldHierarchy,
  getMediaAssets: $state => $state.mediaAssets,
  getMap: $state => $state.map,
  getPins: $state => $state.pins,
};
